// Import the functions you need from the SDKs you need
import { ProjectEntity, Screenplay, Story } from '@/shared/lib/db'
import { firestore } from '@/shared/lib/firebase'
import { collection, doc, getDoc, getDocs, setDoc } from 'firebase/firestore'
import { getScreenplay, getStory } from './local-db'
const db = firestore

export async function syncScriptWithFirebase(userId: string, projectId: string) {
    const screenplay = await getScreenplay(projectId, 'master')
    const scriptRef = doc(db, 'users', userId, 'projects', projectId, 'screenplays', 'master')
    await setDoc(
        scriptRef,
        { content: screenplay?.content, updated_at: screenplay?.updated_at },
        { merge: true }
    )
}

export async function downloadScriptWithFirebase() {
    const scriptRef = doc(db, 'users', 'abhijith', 'scripts', 'dark-knight')
    const dataSnapshot = await getDoc(scriptRef)
    if (dataSnapshot.exists()) {
        return dataSnapshot.data()
    }
}

export async function addProjectToFirestore(project: ProjectEntity) {
    const projectRef = doc(db, 'users', project.userId, 'projects', project.id)
    await setDoc(projectRef, project)
    return project.id
}

export async function getProjectsFromFirestore(userId: string) {
    const projectRef = collection(db, 'users', userId, 'projects')
    const snapshot = await getDocs(projectRef)
    return snapshot.docs
}

export async function addScreenplayToFirestore(screenplay: Omit<Screenplay, 'uid'>) {
    const screenplayRef = doc(
        db,
        'users',
        screenplay.userId,
        'projects',
        screenplay.projectId,
        'screenplays',
        'master'
    )
    await setDoc(screenplayRef, screenplay)
    return screenplay.projectId + '-' + screenplayRef.id
}

export async function getScreenplayFromFirestore(
    userId: string,
    projectId: string,
    fileName: string = 'master'
) {
    const screenplayRef = doc(db, 'users', userId, 'projects', projectId, 'screenplays', fileName)
    const screenplayDoc = await getDoc(screenplayRef)
    return screenplayDoc
}
export async function getScreenplaysFromFirestore(userId: string, projectId: string) {
    const screenplayRef = collection(db, 'users', userId, 'projects', projectId, 'screenplays')
    const screenplayDoc = await getDocs(screenplayRef)
    return screenplayDoc.docs
}

export async function addStoryToFirestore(story: Omit<Story, 'uid'>) {
    const storyRef = doc(
        db,
        'users',
        story.userId,
        'projects',
        story.projectId,
        'stories',
        'master'
    )
    await setDoc(storyRef, story)
    return story.projectId + '-' + storyRef.id
}

export async function getStoryFromFirestore(
    userId: string,
    projectId: string,
    fileName: string = 'master'
) {
    const storyRef = doc(db, 'users', userId, 'projects', projectId, 'stories', fileName)
    const storyDoc = await getDoc(storyRef)
    console.log('>>>>', storyDoc.data())
    if (storyDoc.exists()) {
        return storyDoc.data()
    }
}

export async function getStoriesFromFirestore(userId: string, projectId: string) {
    const storyRef = collection(db, 'users', userId, 'projects', projectId, 'stories')
    const storyDoc = await getDocs(storyRef)
    return storyDoc.docs
}
export async function syncScriptWithFirebaseStory(userId: string, projectId: string) {
    const story = await getStory(projectId, 'master')
    if (!story || !story.content || !story.updated_at) return
    const scriptRef = doc(db, 'users', userId, 'projects', projectId, 'stories', 'master')
    console.log(scriptRef)
    console.log('story content', story.content)
    await setDoc(
        scriptRef,
        { content: story!.content, updated_at: story!.updated_at },
        { merge: true }
    )
}
